import _extends from '@babel/runtime/helpers/esm/extends'
import Vue from 'vue'
import { Popup, Toast } from 'vant'
// import ImagePreview from '../image-preview';
import SkuHeader from './components/SkuHeader'
import SkuHeaderItem from './components/SkuHeaderItem'
import SkuRow from './components/SkuRow'
import SkuRowItem from './components/SkuRowItem'
import SkuStepper from './components/SkuStepper'
// import SkuMessages from './components/SkuMessages';
import SkuActions from './components/SkuActions'
import { createNamespace, isDef } from 'vant/lib/utils'
import { isAllSelected, isSkuChoosable, getSkuComb, getSelectedSkuValues } from './utils/skuHelper'
import { LIMIT_TYPE, UNSELECTED_SKU_VALUE_ID } from './constants'
var namespace = createNamespace('sku')
var createComponent = namespace[0]
var bem = namespace[1]
var t = namespace[2]
var QUOTA_LIMIT = LIMIT_TYPE.QUOTA_LIMIT
export default createComponent({
    props: {
        sku: Object,
        priceTag: String,
        goods: Object,
        value: Boolean,
        skuDetailInitId: Number, // 初始化规格默认id
        buyText: String,
        goodsId: [Number, String],
        hideStock: Boolean,
        addCartText: String,
        stepperTitle: String,
        getContainer: Function,
        hideQuotaText: Boolean,
        hideSelectedText: Boolean,
        resetStepperOnHide: Boolean,
        customSkuValidator: Function,
        closeOnClickOverlay: Boolean,
        disableStepperInput: Boolean,
        safeAreaInsetBottom: Boolean,
        resetSelectedSkuOnHide: Boolean,
        quota: {
            type: Number,
            default: 0
        },
        quotaUsed: {
            type: Number,
            default: 0
        },
        initialSku: {
            type: Object,
            default: function _default (value) {
                return {}
            }
        },
        stockThreshold: {
            type: Number,
            default: 50
        },
        showSoldoutSku: {
            type: Boolean,
            default: true
        },
        showAddCartBtn: {
            type: Boolean,
            default: true
        },
        bodyOffsetTop: {
            type: Number,
            default: 200
        },
        messageConfig: {
            type: Object,
            default: function _default () {
                return {
                    placeholderMap: {},
                    uploadImg: function uploadImg () {
                        return Promise.resolve()
                    },
                    uploadMaxSize: 5
                }
            }
        },
        customStepperConfig: {
            type: Object,
            default: function _default () {
                return {}
            }
        }
    },
    data: function data () {
        return {
            selectedSku: {},
            selectedNum: 1,
            show: this.value
        }
    },
    watch: {
        show: function show (val) {
            this.$emit('input', val)

            if (!val) {
                this.$emit('sku-close', {
                    selectedSkuValues: this.selectedSkuValues,
                    selectedNum: this.selectedNum,
                    selectedSkuComb: this.selectedSkuComb
                })

                if (this.resetStepperOnHide) {
                    this.resetStepper()
                }

                if (this.resetSelectedSkuOnHide) {
                    this.resetSelectedSku(this.skuTree)
                }
            }
        },
        value: function value (val) {
            this.show = val
        },
        skuTree: 'resetSelectedSku',
        initialSku: function initialSku () {
            this.resetStepper()
            this.resetSelectedSku(this.skuTree)
        }
    },
    computed: {
        skuGroupClass: function skuGroupClass () {
            return ['van-sku-group-container', {
                'van-sku-group-container--hide-soldout': !this.showSoldoutSku
            }]
        },
        bodyStyle: function bodyStyle () {
            if (this.$isServer) {
                return
            } // header高度82px, sku actions高度50px，如果改动了样式自己传下bodyOffsetTop调整下

            var maxHeight = window.innerHeight - this.bodyOffsetTop
            return {
                maxHeight: maxHeight + 'px'
            }
        },
        isSkuCombSelected: function isSkuCombSelected () {
            return isAllSelected(this.sku.tree, this.selectedSku)
        },
        isSkuEmpty: function isSkuEmpty () {
            return Object.keys(this.sku).length === 0
        },
        hasSku: function hasSku () {
            return this.sku.none_sku === 1
        },
        selectedSkuComb: function selectedSkuComb () {
            if (!this.hasSku) {
                return this.sku.list.find(item => this.skuDetailInitId === item.id)
            }
            if (this.isSkuCombSelected) {
                return getSkuComb(this.sku.list, this.selectedSku)
            }
            return null
        },
        selectedSkuValues: function selectedSkuValues () {
            return getSelectedSkuValues(this.skuTree, this.selectedSku)
        },
        price: function price () {
            if (this.selectedSkuComb) {
                return (this.selectedSkuComb.price / 100).toFixed(2)
            } // sku.price是一个格式化好的价格区间

            return this.sku.price
        },
        originPrice: function originPrice () {
            if (this.selectedSkuComb && this.selectedSkuComb.origin_price) {
                return (this.selectedSkuComb.origin_price / 100).toFixed(2)
            }

            return this.sku.origin_price
        },
        skuTree: function skuTree () {
            return this.sku.tree || []
        },
        imageList: function imageList () {
            var imageList = [this.goods.picture]

            if (this.skuTree.length > 0) {
                this.skuTree.forEach(function (treeItem) {
                    if (!treeItem.v) {
                        return
                    }

                    treeItem.v.forEach(function (vItem) {
                        var img = vItem.imgUrl || vItem.img_url

                        if (img) {
                            imageList.push(img)
                        }
                    })
                })
            }

            return imageList
        },
        stock: function stock () {
            var stockNum = this.customStepperConfig.stockNum

            if (stockNum !== undefined) {
                return stockNum
            }

            if (this.selectedSkuComb) {
                return this.selectedSkuComb.stock_num
            }

            return this.sku.stock_num
        },
        stockText: function stockText () {
            var h = this.$createElement
            var stockFormatter = this.customStepperConfig.stockFormatter
            if (stockFormatter) return stockFormatter(this.stock)
            return [t('stock') + ' ', h('span', {
                'class': bem('stock-num', {
                    highlight: this.stock < this.stockThreshold
                })
            }, [this.stock]), ' ' + t('stockUnit')]
        },
        quotaText: function quotaText () {
            var _this$customStepperCo = this.customStepperConfig
            var quotaText = _this$customStepperCo.quotaText
            var hideQuotaText = _this$customStepperCo.hideQuotaText
            if (hideQuotaText) return ''
            var text = ''

            if (quotaText) {
                text = quotaText
            } else if (this.quota > 0) {
                text = t('quotaLimit', this.quota)
            }

            return text
        },
        selectedText: function selectedText () {
            var _this = this

            if (this.selectedSkuComb) {
                return t('selected') + ' ' + this.selectedSkuValues.map(function (item) {
                    return item.name
                }).join('；')
            }

            var unselected = this.skuTree.filter(function (item) {
                return _this.selectedSku[item.k_s] === UNSELECTED_SKU_VALUE_ID
            }).map(function (item) {
                return item.k
            }).join('；')
            return t('select') + ' ' + unselected
        }
    },
    created: function created () {
        var skuEventBus = new Vue()
        this.skuEventBus = skuEventBus
        skuEventBus.$on('sku:select', this.onSelect)
        skuEventBus.$on('sku:numChange', this.onNumChange)
        // skuEventBus.$on('sku:previewImage', this.onPreviewImage);
        skuEventBus.$on('sku:overLimit', this.onOverLimit)
        skuEventBus.$on('sku:addCart', this.onAddCart)
        skuEventBus.$on('sku:buy', this.onBuy)
        this.resetStepper()
        this.resetSelectedSku(this.skuTree) // 组件初始化后的钩子，抛出skuEventBus

        this.$emit('after-sku-create', skuEventBus)
    },
    methods: {
        resetStepper: function resetStepper () {
            var skuStepper = this.$refs.skuStepper
            var selectedNum = this.initialSku.selectedNum
            var num = isDef(selectedNum) ? selectedNum : 1

            if (skuStepper) {
                skuStepper.setCurrentNum(num)
            } else {
                this.selectedNum = num
            }
        },
        resetSelectedSku: function resetSelectedSku (skuTree) {
            var _this2 = this
            this.selectedSku = {} // 重置 selectedSku
            if (this.hasSku) {
                skuTree.forEach(function (item) {
                    _this2.selectedSku[item.k_s] = _this2.initialSku[item.k_s] || UNSELECTED_SKU_VALUE_ID
                }) // 只有一个 sku 规格值时默认选中
                skuTree.forEach(function (item) {
                    var key = item.k_s
                    var valueId = item.v[0].id
                    if (item.v.length === 1 && isSkuChoosable(_this2.sku.list, _this2.selectedSku, {
                        key: key,
                        valueId: valueId
                    })) {
                        _this2.selectedSku[key] = valueId
                    }
                })
            }
        },
        getSkuMessages: function getSkuMessages () {
            return this.$refs.skuMessages ? this.$refs.skuMessages.getMessages() : {}
        },
        getSkuCartMessages: function getSkuCartMessages () {
            return this.$refs.skuMessages ? this.$refs.skuMessages.getCartMessages() : {}
        },
        validateSkuMessages: function validateSkuMessages () {
            return this.$refs.skuMessages ? this.$refs.skuMessages.validateMessages() : ''
        },
        validateSku: function validateSku () {
            if (this.selectedNum === 0) {
                return t('unavailable')
            }

            if (this.isSkuCombSelected) {
                return this.validateSkuMessages()
            } // 自定义sku校验

            if (this.customSkuValidator) {
                var err = this.customSkuValidator(this)
                if (err) return err
            }

            return t('selectSku')
        },
        onSelect: function onSelect (skuValue) {
            var _extends2, _extends3
            // 点击已选中的sku时则取消选中
            this.selectedSku = this.selectedSku[skuValue.skuKeyStr] === skuValue.id ? _extends({}, this.selectedSku, (_extends2 = {}, _extends2[skuValue.skuKeyStr] = UNSELECTED_SKU_VALUE_ID, _extends2)) : _extends({}, this.selectedSku, (_extends3 = {}, _extends3[skuValue.skuKeyStr] = skuValue.id, _extends3))
            this.$emit('sku-selected', {
                skuValue: skuValue,
                selectedSku: this.selectedSku,
                selectedSkuComb: this.selectedSkuComb
            })
        },
        onNumChange: function onNumChange (num) {
            this.selectedNum = num
        },
        onPreviewImage: function onPreviewImage (indexImage) {
            // var _this3 = this

            var index = this.imageList.findIndex(function (image) {
                return image === indexImage
            })
            var params = {
                index: index,
                imageList: this.imageList,
                indexImage: indexImage
            }
            this.$emit('open-preview', params)
            // ImagePreview({
            //     images: this.imageList,
            //     startPosition: index,
            //     closeOnPopstate: true,
            //     onClose: function onClose () {
            //         _this3.$emit('close-preview', params)
            //     }
            // })
        },
        onOverLimit: function onOverLimit (data) {
            var action = data.action
            var limitType = data.limitType
            var quota = data.quota
            var quotaUsed = data.quotaUsed
            var handleOverLimit = this.customStepperConfig.handleOverLimit

            if (handleOverLimit) {
                handleOverLimit(data)
                return
            }

            if (action === 'minus') {
                Toast(t('minusTip'))
            } else if (action === 'plus') {
                if (limitType === QUOTA_LIMIT) {
                    var msg = t('quotaLimit', quota)
                    if (quotaUsed > 0) msg += '\uFF0C' + t('quotaCount', quotaUsed)
                    Toast(msg)
                } else {
                    Toast(t('soldout'))
                }
            }
        },
        onAddCart: function onAddCart () {
            this.onBuyOrAddCart('add-cart')
        },
        onBuy: function onBuy () {
            this.onBuyOrAddCart('buy-clicked')
        },
        onBuyOrAddCart: function onBuyOrAddCart (type) {
            var error = this.validateSku()

            if (error) {
                Toast(error)
            } else {
                this.$emit(type, this.getSkuData())
            }
        },
        getSkuData: function getSkuData () {
            return {
                goodsId: this.goodsId,
                selectedNum: this.selectedNum,
                selectedSkuComb: this.selectedSkuComb,
                messages: this.getSkuMessages(),
                cartMessages: this.getSkuCartMessages()
            }
        }
    },
    render: function render () {
        var _this4 = this

        var h = arguments[0]

        if (this.isSkuEmpty) {
            return
        }

        var sku = this.sku
        var goods = this.goods
        var price = this.price
        var originPrice = this.originPrice
        var skuEventBus = this.skuEventBus
        var selectedSku = this.selectedSku
        var selectedNum = this.selectedNum
        var stepperTitle = this.stepperTitle
        var hideQuotaText = this.hideQuotaText
        var selectedSkuComb = this.selectedSkuComb
        var slotsProps = {
            price: price,
            originPrice: originPrice,
            selectedNum: selectedNum,
            skuEventBus: skuEventBus,
            selectedSku: selectedSku,
            selectedSkuComb: selectedSkuComb
        }

        var slots = function slots (name) {
            return _this4.slots(name, slotsProps)
        }

        var Header = slots('sku-header') || h(SkuHeader, {
            'attrs': {
                'sku': sku,
                'goods': goods,
                'skuEventBus': skuEventBus,
                'selectedSku': selectedSku
            }
        }, [slots('sku-header-name') || h('div', {
            'class': 'van-sku__goods-name'
        }, [goods.name]), slots('sku-header-price') || h('div', {
            'class': 'van-sku__goods-price'
        }, [h('span', {
            'class': 'van-sku__price-symbol'
        }, ['\uFFE5']), h('span', {
            'class': 'van-sku__price-num'
        }, [price]), this.priceTag && h('span', {
            'class': 'van-sku__price-tag'
        // eslint-disable-next-line no-mixed-operators
        }, [this.priceTag])]), slots('sku-header-origin-price') || originPrice && h(SkuHeaderItem, [t('originPrice'), ' \uFFE5', originPrice]), !this.hideStock && h(SkuHeaderItem, [h('span', {
            'class': 'van-sku__stock'
        }, [this.stockText]), !hideQuotaText && this.quotaText && h('span', {
            'class': 'van-sku__quota'
        }, ['(', this.quotaText, ')'])]), this.hasSku && !this.hideSelectedText && h(SkuHeaderItem, [this.selectedText]), slots('sku-header-extra')])
        // eslint-disable-next-line no-mixed-operators
        var Group = slots('sku-group') || this.hasSku && h('div', {
            'class': this.skuGroupClass
        }, [this.skuTree.map(function (skuTreeItem) {
            return h(SkuRow, {
                'attrs': {
                    'skuRow': skuTreeItem
                }
            }, [skuTreeItem.v.map(function (skuValue) {
                return h(SkuRowItem, {
                    'attrs': {
                        'skuList': sku.list,
                        'skuValue': skuValue,
                        'selectedSku': selectedSku,
                        'skuEventBus': skuEventBus,
                        'skuKeyStr': skuTreeItem.k_s
                    }
                })
            })])
        })])
        var Stepper = slots('sku-stepper') || h(SkuStepper, {
            'ref': 'skuStepper',
            'attrs': {
                'stock': this.stock,
                'quota': this.quota,
                'quotaUsed': this.quotaUsed,
                'skuEventBus': skuEventBus,
                'selectedNum': selectedNum,
                'selectedSku': selectedSku,
                'stepperTitle': stepperTitle,
                'skuStockNum': sku.stock_num,
                'disableStepperInput': this.disableStepperInput,
                'customStepperConfig': this.customStepperConfig
            },
            'on': {
                'change': function change (event) {
                    _this4.$emit('stepper-change', event)
                }
            }
        })
        var Actions = slots('sku-actions') || h(SkuActions, {
            'attrs': {
                'buyText': this.buyText,
                'skuEventBus': skuEventBus,
                'addCartText': this.addCartText,
                'showAddCartBtn': this.showAddCartBtn
            }
        })
        return h(Popup, {
            'attrs': {
                'closeable': true,
                'position': 'bottom',
                'getContainer': this.getContainer,
                'closeOnClickOverlay': this.closeOnClickOverlay,
                'safeAreaInsetBottom': this.safeAreaInsetBottom,
            },
            'class': 'van-sku-container',
            'model': {
                value: _this4.show,
                callback: function callback ($$v) {
                    _this4.show = $$v
                    _this4.$emit('close', $$v)
                }
            }
        }, [Header, h('div', {
            'class': 'van-sku-body',
            'style': this.bodyStyle
        }, [slots('sku-body-top'), Group, slots('extra-sku-group'), Stepper]), Actions])
    }
})
